export function isDefaultSearch(searchState) {
    return (
        searchState.subjects.data.length === 0 &&
        searchState.tags.data.length === 0 &&
        searchState.educationtypes.data.length === 0 &&
        searchState.counties.data.length === 0 &&
        searchState.counties &&
        searchState.counties.data.length === 0 &&
        searchState.locations &&
        searchState.locations.data.length === 0 &&
        searchState.studyplaces.data.length === 0 &&
        searchState.adtypes.data.length === 0 &&
        searchState.freetext === ""
    );
}
